import {Trans} from 'react-i18next'
import {WithdrawalVendorEnumIndices, WithdrawalPaymentFieldEnumIndices} from '@bdswiss/common-enums'
import messages from '../../../../assets/messages'
import {ReactComponent as BankWireIcon} from '../../../../assets/images/icon-bank-wire.svg'
import {ReactComponent as CryptoIcon} from '../../../../assets/images/icon-crypto.svg'

enum WithdrawalMethodValues {
  bankTransfer = 'bankTransfer',
  cryptocurrency = 'cryptocurrency',
  enovipayCryptoPayout = 'enovipayCryptoPayout',
  payRetailers = WithdrawalVendorEnumIndices.payRetailers,
  enovipayPixPayout = WithdrawalVendorEnumIndices.enovipayPixPayout,
}

const WITHDRAWAL_METHODS_LIST = [
  {
    value: WithdrawalMethodValues.bankTransfer,
    title: <Trans {...messages.bankWire} />,
    processingTimeSubtitle: <Trans {...messages.bankWireProcessingTime} />,
    icon: <BankWireIcon />,
  },
  {
    value: WithdrawalMethodValues.cryptocurrency,
    title: <Trans {...messages.crypto} />,
    processingTimeSubtitle: null,
    icon: <CryptoIcon />,
  },
  {
    value: WithdrawalMethodValues.enovipayCryptoPayout,
    title: <Trans {...messages.cryptoPayout} />,
    processingTimeSubtitle: null,
    icon: <BankWireIcon />,
  },
  {
    value: WithdrawalMethodValues.payRetailers,
    title: <Trans {...messages.localPayout} />,
    processingTimeSubtitle: null,
    icon: <BankWireIcon />,
  },
  {
    value: WithdrawalMethodValues.enovipayPixPayout,
    title: <Trans {...messages.localPayout} />,
    processingTimeSubtitle: null,
    icon: <BankWireIcon />,
  },
]

enum BANK_TRANSFER_FIELD_NAMES {
  iban = 'iban',
  swiftCode = 'swiftCode',
  bankAccountHolderName = 'bankAccountHolderName',
  bankName = 'bankName',
}

const BANK_TRANSFER_DEFAULT_FORM_FIELDS = {
  [BANK_TRANSFER_FIELD_NAMES.iban]: '',
  [BANK_TRANSFER_FIELD_NAMES.swiftCode]: '',
  [BANK_TRANSFER_FIELD_NAMES.bankAccountHolderName]: '',
  [BANK_TRANSFER_FIELD_NAMES.bankName]: '',
}

enum CRYPTO_FIELD_NAMES {
  walletAddress = 'walletAddress',
  walletAddressConfirmation = 'walletAddressConfirmation',
  cryptoNetwork = 'cryptoNetwork',
  walletResponsibilityConfirmation = 'walletResponsibilityConfirmation',
}

const CRYPTO_DEFAULT_FIELD_VALUES = {
  [CRYPTO_FIELD_NAMES.walletAddress]: '',
  [CRYPTO_FIELD_NAMES.walletAddressConfirmation]: '',
  [CRYPTO_FIELD_NAMES.cryptoNetwork]: '',
  [CRYPTO_FIELD_NAMES.walletResponsibilityConfirmation]: false,
}

enum PAY_RETAILERS_FIELD_NAMES {
  bankCode = WithdrawalPaymentFieldEnumIndices.bankCode,
  document = WithdrawalPaymentFieldEnumIndices.document,
  documentType = WithdrawalPaymentFieldEnumIndices.documentType,
  bankAccountType = WithdrawalPaymentFieldEnumIndices.bankAccountType,
  bankAccountNumber = WithdrawalPaymentFieldEnumIndices.bankAccountNumber,
  beneficiaryEmail = WithdrawalPaymentFieldEnumIndices.beneficiaryEmail,
  beneficiaryFirstName = WithdrawalPaymentFieldEnumIndices.beneficiaryFirstName,
  beneficiaryLastName = WithdrawalPaymentFieldEnumIndices.beneficiaryLastName,
  beneficiaryPhone = WithdrawalPaymentFieldEnumIndices.beneficiaryPhone,
}

enum PIX_PAYOUT_FIELD_NAMES {
  pixAccountId = WithdrawalPaymentFieldEnumIndices.pixAccountId,
  pixAccountType = WithdrawalPaymentFieldEnumIndices.pixAccountType,
  pixCustomerIdentity = WithdrawalPaymentFieldEnumIndices.pixCustomerIdentity,
}

const PIX_PAYOUT_DEFAULT_FIELD_VALUES = {
  [PIX_PAYOUT_FIELD_NAMES.pixAccountId]: '',
  [PIX_PAYOUT_FIELD_NAMES.pixCustomerIdentity]: '',
  [PIX_PAYOUT_FIELD_NAMES.pixAccountType]: '',
}

const PAY_RETAILERS_DEFAULT_FIELD_VALUES = {
  [PAY_RETAILERS_FIELD_NAMES.bankCode]: '',
  [PAY_RETAILERS_FIELD_NAMES.document]: '',
  [PAY_RETAILERS_FIELD_NAMES.documentType]: '',
  [PAY_RETAILERS_FIELD_NAMES.bankAccountType]: '0001',
  [PAY_RETAILERS_FIELD_NAMES.bankAccountNumber]: '',
  [PAY_RETAILERS_FIELD_NAMES.beneficiaryEmail]: '',
  [PAY_RETAILERS_FIELD_NAMES.beneficiaryFirstName]: '',
  [PAY_RETAILERS_FIELD_NAMES.beneficiaryLastName]: '',
  [PAY_RETAILERS_FIELD_NAMES.beneficiaryPhone]: '',
}

export {
  WITHDRAWAL_METHODS_LIST,
  BANK_TRANSFER_FIELD_NAMES,
  BANK_TRANSFER_DEFAULT_FORM_FIELDS,
  CRYPTO_FIELD_NAMES,
  CRYPTO_DEFAULT_FIELD_VALUES,
  PAY_RETAILERS_FIELD_NAMES,
  PAY_RETAILERS_DEFAULT_FIELD_VALUES,
  PIX_PAYOUT_FIELD_NAMES,
  PIX_PAYOUT_DEFAULT_FIELD_VALUES,
  WithdrawalMethodValues,
}
